<template>
  <div id="edit-container" :class="webnamefinal">
    <Navigationbar v-if="!isInIframe && !isApp" :webname="webnamefinal">
    </Navigationbar>
    <b-loading
      v-if="!isDataLoaded"
      :is-full-page="true"
      :active="!isDataLoaded"
    ></b-loading>

    <div id="content-frame" v-else>
      <div id="content-inner">
        <div id="content-logo" v-if="!isApp">
          <img :src="logourl" class="top-logo" />
        </div>
        <div id="content-main">
          <EditUser v-bind="$props" v-if="isDataLoaded == true"> </EditUser>
        </div>
      </div>
    </div>

    <Footerbar v-if="!isInIframe && !isApp && isDataLoaded == true">
    </Footerbar>
  </div>
</template>

<script>
import Navigationbar from '@/components/UI/Navigationbar.vue'
import Footerbar from '@/components/UI/Footerbar.vue'
import EditUser from '@/components/EditUser.vue'
import { topLevelPageMixin } from '@/components/mixins/topLevelPageMixin'
import { ToolsMixin } from '@/components/mixins/ToolsMixin'

export default {
  mixins: [topLevelPageMixin, ToolsMixin],
  props: {
    webname: {
      type: String,
      default: ''
    },
    env: {
      type: String,
      default: 'PRO'
    },
    isapp: {
      type: String,
      default: 'false' // navandume
    }
  },
  components: {
    Navigationbar,
    Footerbar,
    EditUser
  },
  computed: {
    isInIframe: function() {
      return window.location != window.parent.location ? true : false
    },
    logourl: function() {
      return process.env.BASE_URL + this.webnamefinal + '/logo.png'
    },
    texts: function() {
      return this.$store.state.decoupled.configFile.texts
    },
    isApp() {
      return this.$store.state.isApp
    }
  },
  methods: {
    setCredentials(slaveJson, serverJson) {
      localStorage.setItem('server_credentials', serverJson)
      localStorage.setItem('slave_credentials', slaveJson)
      this.isCredentialsSet = true
      return true
    },
    initStep2() {
      this.$store.dispatch('auth/initialize')

      this.$store
        .dispatch('auth/getProfile')
        .then(() => {
          console.log('is data loaded')
          this.isDataLoaded = true
        })
        .catch(error => {
          console.log(error)
          if (
            error.response.status === 404 ||
            error.response.status === 403 ||
            error.response.status === 401
          ) {
            this.$store.commit('auth/wrongSession')
            if (this.isApp == false) {
              this.$buefy.toast.open({
                duration: 8000,
                message:
                  'No estas identificado o tu sesión ha caducado. Necesitas acceder de nuevo',
                type: 'is-danger'
              })
              this.$router.replace({ name: 'login' }).catch(() => {})
            } else {
              window.location.href = 'tokmed://wrongSession'
            }
          }
        })
    }
  },
  data() {
    return {
      isDataLoaded: false,
      isCredentialsSet: false
    }
  },
  watch: {
    isCredentialsSet(newValue) {
      if (newValue === true && this.isDataLoaded == false) {
        this.initStep2()
      }
    }
  },

  created() {
    this.$store.commit('setAppMode', this.isapp.toLowerCase() === 'true')
    let promise1 = this.retrieveConfigFilesAndInit()
    promise1.finally(() => {
      if (this.isApp) {
        //this.initStep2()
        window.setCredentials = this.setCredentials
        window.location.href = 'tokmed://getCredentials'
        // now the app will call  setCredentials and trigger the watcher to initStep2
      } else {
        this.initStep2()
      }
    })
  }
}
</script>

<style lang="css" scoped></style>
